export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Infos Google Business',
    google_reviews: 'Avis Google',
    settings: 'Paramètres',
    danger_zone: 'Zone dangereuse',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Réponses automatiques IA',
    },
    reviews_autopilot_daily_limit: {
      label: 'Limite quotidienne des réponses automatiques IA (min 1, max 15)',
    },
    reviews_autopilot_delay_hours: {
      label: "Nombre d'heures à attendre après avoir écrit un avis",
    },
    unanswered_checkbox: {
      show_all_reviews: 'Afficher tous les avis',
      show_only_unanswered: 'Afficher uniquement les avis sans réponse',
    },
    rating_filter: {
      label: 'Filtre par note',
      stars_one: '{{count}} étoile',
      stars_other: '{{count}} étoiles',
    },
    sorting: {
      newest_to_oldest: 'Trier du plus récent au plus ancien',
      oldest_to_newest: 'Trier du plus ancien au plus récent',
      rating_highest_to_lowest: 'Trier par note décroissante',
      rating_lowest_to_highest: 'Trier par note croissante',
    },
  },
  table: {
    pagination: {
      total_one: 'Total {{count}} avis',
      total_other: 'Total {{count}} avis',
    },
  },
  modal_publish: {
    title: 'Êtes-vous sûr de vouloir publier sur Google ?',
    buttons: {
      yes: 'Oui',
      cancel: 'Annuler',
    },
  },
  popconfirm: {
    title: 'Êtes-vous sûr ?',
    description: 'Toutes les modifications locales seront écrasées',
  },
  disconnect_profile: {
    title: 'Déconnecter le profil',
    button: 'Continuer',
    popconfirm: {
      title: 'Êtes-vous sûr ?',
      description:
        'Cela déconnectera complètement ce profil Google du système FoodAmigos, y compris le remplacement automatique des liens et le pilote automatique de réponses aux avis !',
    },
  },
  buttons: {
    login_with_google: 'Se connecter avec Google',
    sync_from_google: 'Obtenir la version récente',
    publish_to_google: 'Publier sur Google',
    previous: 'Précédent',
    next: 'Suivant',
    save_settings: 'Enregistrer les paramètres',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    failed_to_fetch_reviews: 'Échec de la récupération des avis',
    failed_to_fetch_settings: 'Échec de la récupération des paramètres',
    failed_to_load_google_business: 'Échec du chargement de Google Business',
    failed_to_publish_to_google_business: 'Échec de la publication sur Google Business',
    publish_access_denied:
      "Google a refusé la mise à jour : le compte Google connecté ne peut plus modifier ce profil d'établissement. Vérifiez ses droits d'accès dans Google Business Profile ou reconnectez-vous avec le compte qui gère le restaurant.",
    failed_to_fetch_info: "Échec de l'obtention de la version récente de Google Business",
    success_publish_to_google_business: 'Publié avec succès sur Google Business',
    success_sync_from_google: 'Synchronisation depuis Google Business réussie',
    success_save_settings: 'Paramètres enregistrés avec succès',
    failed_to_disconnect_profile: "Échec de la déconnexion de Google Business, veuillez contacter l'équipe technique !",
    popup_blocked: 'Autorisez les fenêtres pop-up pour ce site afin de connecter Google Business.',
    failed_to_connect: 'Impossible de connecter Google Business. Veuillez réessayer.',
    no_business_profile:
      "Ce compte Google ne gère aucune fiche d'établissement. Connectez-vous avec le compte Google qui gère le restaurant.",
  },
  callback: {
    connecting: 'Connexion de Google Business…',
    connected: 'Google Business est connecté. Vous pouvez fermer cette fenêtre.',
    cancelled: 'La connexion a été annulée. Vous pouvez fermer cette fenêtre.',
    failed: 'Impossible de connecter Google Business. Fermez cette fenêtre et réessayez.',
  },
  alerts: {
    no_profile: {
      title: 'Aucun lieu Google connecté',
      description: 'Veuillez connecter le restaurant à un lieu Google.',
      button: {
        connect: 'Connecter',
      },
    },
    unverified_location: {
      title: "Google Business n'est pas vérifié",
      description: 'Vérifiez votre Google Business pour continuer',
    },
  },
};
